export const TIMEZONE_GMT = 'Etc/GMT';

export const DEFAULT_CULTURE_CODE = 'en-US';
export const DEFAULT_LANGUAGE_CODE = 'en-US';

/**
 * A list of language codes that receive official full support in our application.
 *
 * Despite supporting multiple languages, we only provide official full support to the languages listed here.
 * Other languages in the application are supported using a combination of a fallback language and some partially translated texts.
 *
 */
export const FULL_SUPPORT_LANGUAGES = [DEFAULT_LANGUAGE_CODE, 'es-ES', 'fr-FR', 'nl-NL', 'de-DE'];

export const APP_API_IDENTIFIER = 'Mews Web Commander';

/**
 * Default id of a DOM container for react portals.
 * The original portal system was dynamic when there was ModalManager, but now it's just the default constant value.
 */
export const DEFAULT_PORTAL_ID = 'mgr-0-modal-0';

/**
 * The "Mews platform" enterprise has `enterpriseId` set to `null`. This causes some issues
 * where the GUID is required to be presented and formatted properly. This "empty" GUID is used
 * as a placeholder in those cases.
 *
 * In the future, we should fix this discrepancy by assigning Mews platform a GUID too.
 */
export const PLATFORM_ADMIN_ENTERPRISE_ID = '00000000-0000-0000-0000-000000000000';

/* URLs that go outside the app */

export const MEWS_RELEASE_NOTES_URL = 'https://releases.mews.com';
export const MEWS_UNIVERSITY_URL = 'https://university.mews.com';
export const MEWS_COMMUNITY_URL = 'https://community.mews.com';

export const MAX_TINY_INPUT_TEXT_LENGTH = 25;
export const MAX_SMALL_INPUT_TEXT_LENGTH = 70;
export const MAX_MEDIUM_INPUT_TEXT_LENGTH = 128;
export const MAX_LONG_INPUT_TEXT_LENGTH = 2000;

export const MAX_ACCOUNT_NOTE_INPUT_LENGTH = 1000;
export const MAX_LEGAL_IDENTIFIER_INPUT_LENGTH = 50;

/**
 * Script source for the account takeover protection.
 */
export const ACCOUNT_TAKEOVER_SCRIPT_SRC =
    'https://scripts.cdn.mews.com/cdn/ca/mutha-mews-wrapper.js?a=9f89c84a559f573636a47ff8daed0d33';
